import React from 'react';

import { Box } from '@material-ui/core';

import { ContainerModern } from '../common';
import { Typography } from '../common/Typography';

export const NoSubscriptions: React.FC = () => {
  return (
    <ContainerModern>
      <Box mb={4} className='title'>
        <Typography variant='h2' color='textPrimary'>
          Subscriptions
        </Typography>
      </Box>
      <Box mb={4} className='subtitle'>
        <Typography variant='h3' color='textPrimary'>
          You have no active subscriptions.
        </Typography>
        <Typography variant='body1' color='textPrimary'>
          Please choose from the following purchase options.
        </Typography>
      </Box>
      <Box mb={4} className='actions'>
        <a className='button' href='https://enscape3d.com/pricing'>
          Buy online
        </a>
        <Typography variant='body1' color='textPrimary'>
          or{' '}
          <a className='link' href='https://enscape3d.com/reseller'>
            find a reseller
          </a>
        </Typography>
      </Box>
    </ContainerModern>
  );
};
